<template>
  <div id="stock-in">
    <b-card>
      <b-row>
        <b-col md="6">
        <h3>{{ $route.name }}</h3>

        <!-- breadcrumb -->
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item to="/inventory/stock-out/" active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <!-- end breadcrumb -->
      </b-col>

      <b-col md="6">
        <b-button variant="primary" to="stock-out/create" class="float-right btn-custom"
          ><font-awesome-icon icon="plus"
        /></b-button>
      </b-col>
      </b-row>
      <paginated-table
      ref="dataTable"
      :can-edit="false"
      :can-delete="false"
      :can-approve="false"
      :can-reject="false"
      :can-show="true"
      :can-edit-modal="true"
      :can-paid="false"
      :data-url="apiUrl.stockOut"
      :data-key="dataKey"
      :data-columns="columns"
      ></paginated-table>
    </b-card>
  </div>
</template>
<script>
import PaginatedTable from '../../../components/PaginatedTable.vue'
export default {
  components: { PaginatedTable },
  data(){
    return {
      dataKey: 'stock_out',
      apiUrl: {
        stockOut: window.AppConfig.apiUrl + 'stock-out?'
      },
      model:{
        stockOutId: null,
        stockOutDate: null,
        stockOutNote: null,
        stockArea: null,
        journalAccount: null,
        stockOutItem: null,
        stockOutItemNote: null,
        stockOutItemQuantity: null,
        stockOutItemPrice: null,
        itemList: null,
        stockOut: null,
      },
      columns: [
        {
          key: 'stockOutId',
          label: 'Stock Out Id',
          sortable: true
        },
        {
          key: 'stockOutDate',
          label: 'Stock Out Date',
          sortable: true
        },
        {
          key: 'stockOutNote',
          label: 'Stock Out Note',
          sortable: true
        },
        {
          key: 'stockArea.areaName',
          label: 'Stock Area',
          sortable: true
        },
        {
          key: 'actionStockOut',
          label: '',
          sortable: true
        },
      ]
    }
  }
}
</script>